export const TOOLS = [
  'rectangle', 'polygon', 'point', 'circle', 'multipoint',
  'polyline', 'mesh', 'freehandPolyline', 'freehandPolygon',
] as const;

export type Tool = typeof TOOLS[number];

export const GEOMETRY_TYPES = ['point', 'polyline', 'polygon', 'mesh'] as const;
export type GeometryType = typeof GEOMETRY_TYPES[number];

// 2) Mapping mit strenger Typprüfung
export const TOOL_MAP = {
  point: ['point', 'multipoint'],
  polyline: ['polyline', 'freehandPolyline'],
  polygon: ['polygon', 'freehandPolygon', 'rectangle', 'circle'],
  mesh: ['mesh'],
} as const satisfies Record<GeometryType, readonly Tool[]>;

// 3) kleine Runtime-Typeguards (optional)
export function isTool(x: unknown): x is Tool {
  return typeof x === 'string' && (TOOLS as readonly string[]).includes(x);
}

export function isGeometryType(x: unknown): x is GeometryType {
  return typeof x === 'string' && (GEOMETRY_TYPES as readonly string[]).includes(x);
}
